<template>
<div class="chapter">
<div class="inner_page">
<p class="cn" id="ch4">BIRTH TO OUR PEOPLE</p>
<p class="v">Birth to our people—it was she,</p>
<p class="v">Shepherdess Inception, who</p>
<p class="v">gave birth to our people. How?</p>
<p class="v">She offered sacrifice, prayers</p>
<p class="v">that she not be without child,</p>
<p class="v">wandered the Lord’s footprint, quickened</p>
<p class="v">and conceived. She grew round,</p>
<p class="v">dawn-life stirring there within,</p>
<p class="v">she gave birth and she suckled,</p>
<p class="vsb">and the child—it was Millet God.</p>
<p class="v">And so those months eased by</p>
<p class="v">and the birth—it was effortless.</p>
<p class="v">Free of all rending and tearing,</p>
<p class="v">free of pain and affliction, she</p>
<p class="v">brought forth divine splendor.</p>
<p class="v">The Celestial Lord soothing her,</p>
<p class="v">welcoming sacrifice and prayer,</p>
<p class="vsb">she bore her son in tranquillity.</p>
<p class="v">And so he was left alone in a narrow lane,</p>
<p class="v">but oxen and sheep nurtured him.</p>
<p class="v">And so he was left alone on a forested plain,</p>
<p class="v">but woodcutters gathered round.</p>
<p class="v">And so he was left alone on a cold ice-field,</p>
<p class="v">but birds wrapped him in wings,</p>
<p class="v">and when the birds took flight,</p>
<p class="v">Millet God began to wail, he</p>
<p class="v">wailed long and wailed loud,</p>
<p class="vsb">and the sound was deafening.</p>
<p class="v">And so he soon began to crawl,</p>
<p class="v">then stood firm as a mountain.</p>
<p class="v">When he began to feed himself</p>
<p class="v">he planted broad-beans aplenty,</p>
<p class="v">broad and wind-fluttered beans,</p>
<p class="v">and lush grain ripening in rows,</p>
<p class="v">wheat and hemp thick and rich,</p>
<p class="vsb">and melons sprawled everywhere.</p>
<p class="v">And so Millet God farmed, understanding</p>
<p class="v">the Way to help things grow.</p>
<p class="v">He cleared away thick grass</p>
<p class="v">and planted yellow treasure.</p>
<p class="v">The seeds swelled and rooted.</p>
<p class="v">Planted well, they grew lovely,</p>
<p class="v">grew tall and lovely in bloom,</p>
<p class="v">they ripened to a fine finish</p>
<p class="v">and bent low with rich plenty.</p>
<p class="vsb">He built a house there, in T’ai, and settled.</p>
<p class="v">And so he gave to us exquisite</p>
<p class="v">millet: midnight and twin-seed,</p>
<p class="v">red-shafted and white-frosted.</p>
<p class="v">He grew midnight and twin-seed</p>
<p class="v">far and wide, cut acre after acre,</p>
<p class="v">cut red-shafted and white-frosted,</p>
<p class="v">hauled it in, shoulder and back</p>
<p class="vsb">home to begin offering sacrifice.</p>
<p class="v" id="pg13">And so our offerings—how are they done?</p>
<p class="v">Some thresh and some sweep,</p>
<p class="v">some winnow and some tread;</p>
<p class="v">we wash it clean, whisper-clean,</p>
<p class="v">and steam it misty, misty sweet.</p>
<p class="v">Pondering deeply, thoughts pure,</p>
<p class="v">we offer artemisia soaked in fat,</p>
<p class="v">offer rams to spirits far and wide,</p>
<p class="v">and meat smoke-seared we offer</p>
<p class="vsb">to bring forth another new year.</p>
<p class="v">We offer bounty in altar bowls,</p>
<p class="v">in altar bowls and holy platters,</p>
<p class="v">and when the fragrance ascends,</p>
<p class="v">fragrance perfect in its season,</p>
<p class="v">our Celestial Lord rests content.</p>
<p class="v">Millet God began these offerings,</p>
<p class="v">and free of trespass always they</p>
<p class="v">continued down to our own time.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?01fe2ef4